<template>
  <div>
    <div v-for="option in question.options" :key="option.label" class="mb-2">
      <b-button block :variant="(option == value) ? 'primary' : 'light'" @click="select(option)">
        {{option.label}}
      </b-button>
    </div>
  </div>
</template>
<script>
export default {
  props: {
    question: {
      type: Object,
    },
  },
  data() {
    return {
      value: null,
    };
  },
  methods: {
    select(selectedOption) {
      this.value = selectedOption;
      const answer = {
        value: selectedOption.label,
        score: (selectedOption.score || 0),
        jumpTo: selectedOption.jumpTo,
        opportunity: selectedOption.opportunity,
      };
      setTimeout(() => {
        this.$emit('answered', answer);
      }, 300);
    },
  },
};
</script>
